module.exports = __webpack_public_path__ + "img/3.9af7ae7b.png";